import { OP } from '../api/operations';

const BY_OPERATION = Object.freeze({
  [OP.pipeline.runByName]: 'Pipeline ran successfully.',
  [OP.node.appendInputSelect]: 'Input node added successfully.',
  [OP.node.deleteFromPipeline]: 'Node deleted successfully.',
  [OP.node.reconfigure]: 'Node reconfigured successfully.',
  [OP.node.appendNormalizer]: 'Normalizer node added successfully.',
  [OP.node.editNormalizer]: 'Normalizer node updated successfully.',
  [OP.node.appendScaler]: 'Scaler node added successfully.',
  [OP.node.editScaler]: 'Scaler node updated successfully.',
  [OP.node.appendCapper]: 'Capper node added successfully.',
  [OP.node.editCapper]: 'Capper node updated successfully.',
  [OP.node.appendFinance]: 'Finance node added successfully.',
  [OP.node.editFinance]: 'Finance inputs saved successfully.',
  [OP.node.appendConsumptionInput]: 'Consumption node added successfully.',
  [OP.node.appendWindGeneration]: 'Wind generation node added successfully.',
  [OP.node.editWindGeneration]: 'Wind generation node updated successfully.',
  [OP.node.appendSolarGeneration]: 'Solar generation node added successfully.',
  [OP.node.editSolarGeneration]: 'Solar generation node updated successfully.',
  [OP.node.appendLoan]: 'Loan node added successfully.',
  [OP.node.editLoan]: 'Loan node updated successfully.',
  [OP.node.appendDepreciation]: 'Depreciation node added successfully.',
  [OP.node.editDepreciation]: 'Depreciation node updated successfully.',
  [OP.node.appendOperationalCosts]: 'Operational costs node added successfully.',
  [OP.node.editOperationalCosts]: 'Operational costs node updated successfully.',
  [OP.node.appendAdder]: 'Adder node added successfully.',
  [OP.node.appendMerger]: 'Adder node added successfully.',
  [OP.node.editAdder]: 'Adder node updated successfully.',
  [OP.node.appendMatcher]: 'Matcher node added successfully.',
  [OP.node.editMatcher]: 'Matcher node updated successfully.',
  [OP.node.appendLossSubtractor]: 'Loss subtractor node added successfully.',
  [OP.node.editLossSubtractor]: 'Loss subtractor node updated successfully.',
  [OP.node.appendExtrapolation]: 'Extrapolation node added successfully.',
  [OP.node.editExtrapolation]: 'Extrapolation node updated successfully.',
  [OP.node.appendBanking]: 'Banking node added successfully.',
  [OP.node.appendSettle]: 'Settle node saved successfully.',
  [OP.node.updateBankingType]: 'Banking node updated successfully.',
  [OP.genUpload.uploadDataFile]: 'File uploaded successfully.',
});

export function getSuccessMessage(operation) {
  if (!operation) return '';
  return BY_OPERATION[operation] || '';
}
